/**
 * Wraps an action that a read-only (trial-ended / cancelled) workspace must not
 * be able to start, and explains why on hover.
 *
 * Why a wrapper span: a `disabled` button emits no mouse events, so a Tooltip
 * placed directly on one never opens — the user would get a dead button and no
 * reason. The span is the hover target; `pointer-events: none` on the child
 * swallows the click without relying on every call site remembering to guard
 * its own onClick.
 *
 * Renders children untouched when unlocked, so it is safe to leave in place.
 */
import React from 'react';
import { Tooltip } from 'antd';
import { useWorkspaceLock } from '../context/workspaceLock';

export default function LockedActionTooltip({ children, placement = 'top', block = false }) {
  const { locked, message } = useWorkspaceLock();
  if (!locked) return children;
  return (
    <Tooltip title={message} placement={placement}>
      <span
        style={{
          display: block ? 'block' : 'inline-block',
          cursor: 'not-allowed',
          width: block ? '100%' : undefined,
        }}
      >
        <span style={{ pointerEvents: 'none', opacity: 0.5, display: block ? 'block' : 'inline-block' }}>
          {children}
        </span>
      </span>
    </Tooltip>
  );
}
